import { appState } from '../model/appState'

export function getPersonIdFromUrl() {
	const it = appState.pathMatch?.pathname.groups.personId
	return it ? decodeURIComponent(it) : undefined
}
